import { IConfig } from '@vivli/shared/infrastructure/interface';

export const useB2CAuthority = (config: IConfig): string => {
    // The configured policy is always authoritative. This used to be cached in a 'policyName' cookie
    // and preferred over config, which meant a browser that had already visited kept building the
    // global MSAL authority from whatever policy was configured at the time - stale after a policy
    // change.
    const b2cName = config?.b2CTenant.split('.')[0];

    return `https://${b2cName}.b2clogin.com/${config?.b2CTenant}/${config?.b2CSignUpSignInPolicyName}`;
};
